/* eslint-disable max-lines */
import { useState, useEffect, useContext } from 'react';
import { Box, Grid, InputLabel, Radio, Typography, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import EliteImage2 from '../../../images/EliteAccImg2.png';
import ProductIndex from '../ProductQuestion/Product';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { getProductQuestions, saveProductInformation } from '../../../services/formService';
import { ProductUIStyles } from './ProductUIStyles';
import { LayoutStyles as layoutClasses } from '../../Bundle/LayoutStyles';
import InfoIcon from '../../../images/information-icon.svg';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import { productNameURLMapping } from '../../../services/productNameURLMapping';
import {
  ACCOUNT_NUMBER,
  BANK,
  BANK_NAME,
  DEBIT_CARD,
  DEBIT_CARD_INFO_TEXT,
  DEBIT_CARD_NOT_REQUIRED_TEXT,
  DEBIT_CARD_REQUIRED_TEXT,
  DIRECT_DEPOSITE,
  DIRECT_DEPOSITE_RADIO_TEXT,
  DIRECT_DEPOSITE_RADIO_TEXT_NO,
  DIRECT_DEPOSITE_TEXT,
  ELITE_ACCOUNT_EN,
  ENTER_ACCOUNT_NUMBER,
  ENTER_TRANSIT_NUMBER,
  ESTATEMENT_BANKING,
  ESTATEMENT_TEXT,
  E_STATEMENTS,
  E_STATEMENT_FEE_WAIVED_AGED,
  E_STATEMENT_MONTHLY_FEE,
  INTEREST_PAYMENT_METHOD,
  INTEREST_PAYMENT_METHOD_TEXT,
  INVALID_FORMAT_ERR,
  MANDATORY_FIELD_ERR,
  OTHER,
  PRODUCTUI_PAGE_KEY,
  PRODUCTUI_PAGE_VALUE,
  PROGRESA_CONTIGO,
  PROGRESA_CONTIGO_BANKING,
  PROGRESA_CONTIGO_ESTATEMENT,
  PROGRESA_CONTIGO_ESTATEMENT_TEXT,
  PROGRESA_CONTIGO_FEE_EXEMPTION,
  PROGRESA_CONTIGO_MONTHLY_FEE,
  REQUIRED,
  SELECT_METHOD,
  TRANSIT_NUMBER,
  TYPE_OF_ACCOUNT,
  LIBRE_AHORRA_BUNDLE,
  APPLY_TWO_ACCOUNTS,
  CD_IRA,
} from '../../../constants';
import {
  commonUtility,
  getProductForDebitCard,
  getProductForDepositeCard,
  getProductForEstatement,
} from '../UtilityFunctions';
import Layout from '../../Layout';
import { businessMapping } from '../../../services/businessMapping';
import { productTypeMapping } from '../../../services/productTypeMapping';
import RetailImage2 from '../../../images/Retail_Image_2.png';
import ComercialImage3 from '../../../images/Comercial_Image_3.png';
import { productMapping } from '../../../services/productMapping';
import SaveAppContactInfo from '../../SaveApp/SaveAppContactInfo';
import { CustomSelect } from '../CustomSelect/CustomSelect';
import { CustomInput } from '../CustomInput/CustomInput';
import {
  commonTernary,
  isBundle,
  isCDIraproduct,
  isCDproduct,
  isEtbFlow,
  isPlaidProduct,
  yearCalculatorPR,
} from '../../commonCode';
import { CustomSelectAccountNo } from '../CustomSelect/CustomSelectAccountNo';
import { getOrientalAccountNumber } from '../../../services/plaidService';
import NewLayout from '../../Bundle/NewLayout';
import CustomSwitch from '../Switch/CustomSwitch';
import CommonTab from '../../Bundle/ProductTrans';
import { getQuestionAndAnswers } from '../../../services/formServiceUtils';
import ProductCDIRA from '../ProductQuestion/ProductCDIRA';

const CustomRadio = styled(Radio)(({ theme }) => ({
  color: '#661C69',
  '&.Mui-checked': {
    color: '#661C69',
  },
}));

function Product(props) {
  const { t } = useTranslation();
  const [isValidating, setIsValidating] = useState(false);
  const themes = useTheme();

  const isMobile = useMediaQuery(themes?.breakpoints?.down('1034'), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(themes?.breakpoints?.down('600'), {
    defaultMatches: true,
  });
  const leadGenerationContext = useContext(LeadGenerationContext);
  const styledClasses = ProductUIStyles(leadGenerationContext?.theme);
  const [bankTransitNumbers, setBankTransitNumbers] = useState([]);
  const [banks, setBanks] = useState([]);
  const [translation, setTranslation] = useState(leadGenerationContext.productQuestionsEN);
  useEffect(() => {
    if (leadGenerationContext.language === 'EN') {
      setTranslation(leadGenerationContext.productQuestionsEN);
    }
    if (leadGenerationContext.language === 'ES') {
      setTranslation(leadGenerationContext.productQuestionsES);
    }
  }, [leadGenerationContext.language]);

  const yearData = yearCalculatorPR();

  const { isBtwAprilAndDecember } = yearData;
  const { history } = props;
  const {
    productData,
    setProductData,
    productDataSavings,
    setProductDataSavings,
    items,
    setItems,
    itemsAnswer,
    setItemsAnswer,
    setFormAnswer,
    productType,
    language,
    location,
    setCurrentPage,
    productQuestionsEN,
    productQuestionsES,
    isScreenFiveDirty,
    setIsScreenFiveDirty,
    bankDetails,
    setBankDetails,
    setIsFundingScreenDirty,
    accessToken,
    debitCardDisburse,
    setDebitCardDisburse,
    debitCardNotRequired,
    setDebitCardNotRequired,
    isCommercialProductUIDirty,
    setIsCommercialProductUIDirty,
    setInternationalWireTransferError,
    setCountries,
    setReceivedCountryData,
    setCountryList,
    savedDataFlow,
    savedItemsAnswer,
    savedFormAnswer,
    setSavedItemsAnswer,
    setSavedFormAnswer,
    isModalSaveLater,
    setIsModalSaveLater,
    customerType,
    flowTypeETB,
    customerAppId,
    depositeCardDisburse,
    setDepositeCardDisburse,
    interestPaymentMethod,
    setInterestPaymentMethod,
    interestPaymentMethodErr,
    setInterestPaymentMethodErr,
    accNoListForOrientalAccount,
    setAccNoListForOrientalAccount,
    setSelectedOrientalAccountProgress,
    productName,
    productAccountType,
    setProductAccountType,
    setItemsAnswerSavings,
    itemsAnswerSavings,
    savedItemsAnswerSavings,
    itemsSavings,
    setItemsSavings,
    setFormAnswerSavings,
    productTabVal,
    formAnswerSavings,
    formAnswer,
    setProductTabVal,
    librePlusApiCall,
    setSavedItemsAnswerSavings,
    savedFormAnswerSavings,
    setProductDataIRAErrors,
    setFundData,
    fundData,
  } = leadGenerationContext;

  const [libreAccountError, setLibreAccountError] = useState(false);
  const [ahorraAccountError, setAhorraAccountError] = useState(false);
  const [commonAccountError, setCommonAccountError] = useState(false);

  useEffect(() => {
    if (
      Object.keys(leadGenerationContext.formAnswerSavings ?? {}).length > 0 &&
      !productAccountType
    ) {
      setLibreAccountError(false);
    }
    if (Object.keys(leadGenerationContext.formAnswer ?? {}).length > 0 && !productAccountType) {
      setAhorraAccountError(false);
    }
    if (Object.keys(leadGenerationContext.formAnswer ?? {}).length > 0 && productAccountType) {
      setCommonAccountError(false);
    }
  }, [
    productAccountType,
    leadGenerationContext.formAnswer,
    leadGenerationContext.formAnswerSavings,
  ]);

  useEffect(() => {
    const bankList = [];
    if (bankDetails && bankDetails?.length > 0) {
      for (const element of bankDetails) {
        bankList.push(element.bankName);
      }
    }
    setBanks(bankList);
    if (interestPaymentMethod?.bank) {
      if (bankDetails && bankDetails?.length > 0) {
        let bank = '';
        for (const element of bankDetails) {
          if (element.bankName === interestPaymentMethod?.bank) {
            bank = element;
            break;
          }
        }
        bankTransitNumbersCall(bank);
      }
    }
  }, [bankDetails]);

  const bankTransitNumbersCall = (bank) => {
    if (bank && bank.transistNumbers) {
      const transitNumbers = bank?.transistNumbers;
      if (!transitNumbers?.includes('Other')) {
        transitNumbers.push('Other');
      }
      if (transitNumbers && transitNumbers?.length > 0) {
        setBankTransitNumbers(transitNumbers);
      } else {
        setBankTransitNumbers([]);
      }
    } else {
      setBankTransitNumbers([]);
    }
  };
  const savedDataProduct = () => {
    if (savedDataFlow && isBundle(productName)) {
      leadGenerationContext?.setItemsAnswer(leadGenerationContext?.savedItemsAnswer);
      leadGenerationContext?.setItemsAnswerSavings(leadGenerationContext?.savedItemsAnswerSavings);
    }
  };

  useEffect(() => {
    if (savedDataFlow) {
      setFormAnswer(savedFormAnswer);
      setFormAnswerSavings(savedFormAnswerSavings);
      const list = [];
      if (Object.prototype.hasOwnProperty.call(productData, 'transactionCountry')) {
        // eslint-disable-next-line guard-for-in
        for (const con in productData?.transactionCountry[0]?.countryCodes) {
          list.push({
            country: con,
            code: productData?.transactionCountry[0].countryCodes[con],
          });
        }
      }
      if (
        Object.prototype.hasOwnProperty.call(productDataSavings, 'transactionCountry') &&
        isBundle(productName)
      ) {
        // eslint-disable-next-line guard-for-in
        for (const con in productDataSavings?.transactionCountry[0]?.countryCodes) {
          list.push({
            country: con,
            code: productDataSavings.transactionCountry[0].countryCodes[con],
          });
        }
      }
      const matchingCountries = [];
      Object.keys(savedFormAnswer || {})?.forEach((key) => {
        if (key.includes('TransactionCountry')) {
          const transactionCountries = savedFormAnswer[key];
          transactionCountries.forEach((countryCode) => {
            const matchingCountry = list?.find((country) => country.code === countryCode);
            if (matchingCountry) {
              matchingCountries.push(matchingCountry);
            }
          });
        }
      });
      setCountries(matchingCountries);
    }
    savedDataProduct();
  }, [savedDataFlow, productData, productDataSavings]);
  useEffect(() => {
    if (
      leadGenerationContext.customerType === 'NTB' &&
      interestPaymentMethod.typeOfAccount === null &&
      interestPaymentMethod.accountNumber === null &&
      interestPaymentMethod.routingNumber === null
    ) {
      setInterestPaymentMethod((prevState) => ({
        ...prevState,
        accuredIntMethod: 'Deposit interest in external account',
      }));
    }
  }, []);
  useEffect(() => {
    if (!itemsAnswer.InternationalWireTransfer) {
      setCountries([]);
      setInternationalWireTransferError('');
      setReceivedCountryData([]);
      setCountryList([]);
    }
  }, [itemsAnswer]);

  const getProdQuestionsRule = () => {
    if (
      businessMapping(productName) &&
      (productTypeMapping(productType) === 'Checking Account' ||
        productTypeMapping(productType) === 'Savings Account')
    ) {
      return 'ProductQuestionsCommercial';
    }
    return 'ProductQuestions';
  };

  const handleOnLoadProductPage = async () => {
    setCurrentPage('product-info');
    const formData = {
      productType,
      productName,
      language,
      location,
      customerType,
      flowTypeETB,
      customerAppId,
    };
    if (
      accessToken &&
      Object.keys(productQuestionsEN).length > 0 &&
      Object.keys(productQuestionsES).length > 0 &&
      !isCDIraproduct(productName)
    ) {
      setIsValidating(true);
      const prodRule = getProdQuestionsRule();
      setIsValidating(true);

      const prodData = await getProductQuestions(formData, prodRule, accessToken);
      // const prodData = TransactionScren;

      if (prodData?.data) {
        let data;
        let dataSavings;

        if (prodRule === 'ProductQuestionsCommercial') {
          data = prodData?.data?.ProductQuestionsCommercial?.[0];
        } else if (!isBundle(productName)) {
          data = prodData?.data?.ProductQuestions?.[0];
        } else if (isBundle(productName)) {
          data = prodData?.data?.ProductQuestions?.[0];

          dataSavings = prodData?.data?.ProductQuestions?.[1];
        }

        if (prodData?.data?.ProductQuestions) {
          setBankDetails(data?.bankInfo);
        }
        if (Object.keys(commonTernary(productData, productData, {}))?.length === 0) {
          data?.questions?.forEach((question) => {
            itemsAnswer[question.name] = '';
          });
          setItemsAnswer(itemsAnswer);

          if (Object.keys(savedItemsAnswer || {})?.length === 0) {
            setSavedItemsAnswer(itemsAnswer);
          }
        }
        if (Object.keys(commonTernary(productDataSavings, productDataSavings, {}))?.length === 0) {
          dataSavings?.questions?.forEach((question) => {
            itemsAnswerSavings[question.name] = '';
          });
          setItemsAnswerSavings(itemsAnswerSavings);

          if (Object.keys(savedItemsAnswerSavings || {})?.length === 0) {
            setSavedItemsAnswerSavings(itemsAnswerSavings);
          }
        }
        setProductData(isBundle(productName) ? dataSavings : data);
        setProductDataSavings(data);
        setIsValidating(false);
      }
    }
  };

  useEffect(() => {
    handleOnLoadProductPage();
  }, [accessToken, productQuestionsEN, productQuestionsES]);
  useEffect(() => {
    if (
      productData &&
      Object.keys(itemsAnswer)?.length === 0 &&
      Object.keys(itemsAnswerSavings)?.length === 0 &&
      isBundle(productName)
      // !productAccountType
    ) {
      // if (Object.keys(commonTernary(productData, productData, {}))?.length === 0) {
      productData?.questions?.forEach((question) => {
        itemsAnswer[question.name] = '';
      });
      setItemsAnswer(itemsAnswer);
      if (Object.keys(savedItemsAnswer).length === 0) {
        setSavedItemsAnswer(itemsAnswer);
      }
      // }
      // if (Object.keys(commonTernary(productDataSavings, productDataSavings, {}))?.length === 0) {
      productDataSavings?.questions?.forEach((question) => {
        itemsAnswerSavings[question.name] = '';
      });
      setItemsAnswerSavings(itemsAnswerSavings);

      if (Object.keys(savedItemsAnswerSavings).length === 0) {
        setSavedItemsAnswerSavings(itemsAnswerSavings);
      }
      // }
    }
  }, [productAccountType]);

  let appId;
  if (flowTypeETB === 'EtbFlow') {
    appId = leadGenerationContext.customerAppId;
  } else {
    appId = leadGenerationContext.applicationId;
  }

  const handleOrientaAccountApi = async () => {
    if ((isCDproduct(productName) || savedDataFlow) && customerType === 'ETB') {
      if (appId && leadGenerationContext.accessToken) {
        setIsValidating(true);
        const accountsResponse = await getOrientalAccountNumber(
          appId,
          leadGenerationContext.accessToken
        );
        if (accountsResponse && accountsResponse.status === 200) {
          setIsValidating(false);
          // set response to setAccNoListForOrientalAccount,

          if (accountsResponse.data?.length > 0) {
            const updateAccountDetails = accountsResponse.data.map((option) => {
              const isDepositeGreaterThanBalance = false;
              // const val = option.Balance.replace(/,/g, '');
              // const balance = parseFloat(val);
              // if (option.Balance !== '') {
              //   isDepositeGreaterThanBalance = balance < data.fundingAmount[0]?.minimumAmount;
              // }
              return { ...option, isDepositeGreaterThanBalance };
            });
            setAccNoListForOrientalAccount(updateAccountDetails);
          } else if (
            accountsResponse.data?.length < 1 &&
            customerType === 'ETB' &&
            isPlaidProduct(leadGenerationContext.productName)
          ) {
            setAccNoListForOrientalAccount([]);
            // setInterestPaymentMethod((prevState) => ({
            //   ...prevState,
            //   orientalAccount: false,
            //   anotherBankAccount: true,
            // }));
          }
        } else {
          // setCallPlaidLink(true);
          setIsValidating(false);
        }
      }
    } else {
      // setCallPlaidLink(true);
      setIsValidating(false);
    }
  };

  useEffect(() => {
    handleOrientaAccountApi();
  }, []);

  const handleData = (newItem) => {
    if (isBundle(productName) && productTabVal === 0 && !productAccountType) {
      const formAnswerSaving = { ...leadGenerationContext.formAnswerSavings };
      const newFormAnswerSavings = {};
      for (const property in formAnswerSaving) {
        if (!property.startsWith(`${newItem.name}_`)) {
          newFormAnswerSavings[property] = formAnswerSaving[property];
        }
      }
      setFormAnswerSavings(newFormAnswerSavings);
      const val = newItem.next.find((element) => element.value === 'false');
      const questionIndx = productData?.questions?.findIndex((item) => {
        if (val?.questions?.length > 0) {
          return item.name === val.questions[0];
        }
        return false;
      });
      let newItms = [];
      if (questionIndx > 0) {
        if (!itemsSavings.includes(questionIndx)) {
          newItms = [...itemsSavings, questionIndx];
        } else {
          newItms = [...itemsSavings];
        }
      } else {
        newItms = [...itemsSavings];
      }
      setItemsSavings(newItms);
    } else if (
      (isBundle(productName) && productTabVal === 1) ||
      !isBundle(productName) ||
      productAccountType
    ) {
      const formAnswers = { ...leadGenerationContext.formAnswer };
      const newFormAnswer = {};
      for (const property in formAnswers) {
        if (!property.startsWith(`${newItem.name}_`)) {
          newFormAnswer[property] = formAnswers[property];
        }
      }
      setFormAnswer(newFormAnswer);
      const value = newItem.next.find((element) => element.value === 'false');
      const questionIndex = productDataSavings?.questions?.findIndex((item) => {
        if (value?.questions?.length > 0) {
          return item.name === value.questions[0];
        }
        return false;
      });
      let newItems = [];
      if (questionIndex > 0) {
        if (!items.includes(questionIndex)) {
          newItems = [...items, questionIndex];
        } else {
          newItems = [...items];
        }
      } else {
        newItems = [...items];
      }
      setItems(newItems);
    }
  };
  const handleChangeData = (newItem) => {
    if (isBundle(productName) && productTabVal === 0 && !productAccountType) {
      const indx = itemsSavings.findIndex((item) => {
        if (productData?.questions?.[item]?.subQuestions) {
          return productData.questions[item].subQuestions.includes(newItem.name);
        }
        return productData.questions[item].name === newItem.name;
      });
      let newItms = [];
      if (indx >= 0) {
        items.splice(indx + 1, items.length - 1 - indx);
        newItms = [...items];
      } else {
        newItms = [...items];
      }
      setItemsSavings(newItms);
    } else if (
      (isBundle(productName) && productTabVal === 1) ||
      !isBundle(productName) ||
      productAccountType
    ) {
      const index = items.findIndex((item) => {
        if (productDataSavings?.questions?.[item]?.subQuestions) {
          return productDataSavings.questions[item].subQuestions.includes(newItem.name);
        }
        return productDataSavings.questions[item].name === newItem.name;
      });
      let newItems = [];
      if (index >= 0) {
        items.splice(index + 1, items.length - 1 - index);
        newItems = [...items];
      } else {
        newItems = [...items];
      }
      setItems(newItems);
    }
  };
  const handlesubQuestions = (subQuestionAnswered) => {
    let newitemdata;
    if (subQuestionAnswered === true) {
      newitemdata = true;
      return newitemdata;
    }
    if (subQuestionAnswered === false) {
      newitemdata = false;
      return newitemdata;
    }
  };
  const handlesubQue = (subQuestions, newItemsAnswer) => {
    if (subQuestions?.length > 0) {
      let dataitem;
      for (const itemSubQue of subQuestions) {
        if (newItemsAnswer[itemSubQue]) {
          dataitem = true;
          break;
        }
      }
      return dataitem;
    }
  };
  const handleresult = (result, newItem) => {
    if (result === false) {
      handleData(newItem);
    } else {
      handleChangeData(newItem);
    }
  };

  const handleitem = (property, newItem, newItemsAnswer, result, newElementsAnswer) => {
    let toy;
    if (property === newItem.name) {
      toy = { ...newItemsAnswer, [property]: result };
    } else {
      toy = {
        ...newItemsAnswer,
        [property]: newElementsAnswer[property],
      };
    }
    return toy;
  };
  const samplefunction = (productData1, newItemsAnswer) => {
    const newItemsAnswer1 = newItemsAnswer;
    if (productData1?.questions) {
      for (const item of productData1.questions) {
        const question = item;
        const { subQuestions } = question;
        let subQuestionAnswered = false;
        const callsubque = true;
        if (callsubque === true) {
          subQuestionAnswered = handlesubQue(subQuestions, newItemsAnswer1);
        }
        if (subQuestions?.length > 0) {
          newItemsAnswer1[question.name] = handlesubQuestions(subQuestionAnswered);
        }
        if (subQuestionAnswered) {
          newItemsAnswer1[question.name] = true;
        }
      }
    }
    return newItemsAnswer1;
  };
  const itemsHandler = (newItem, result) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFeatureScreenDirty(true);
    setIsFundingScreenDirty(true);

    if (isBundle(productName) && productTabVal === 0 && !productAccountType) {
      const newElementsAnswr = { ...itemsAnswerSavings, [newItem.name]: result };
      setItemsAnswerSavings(newElementsAnswr);
      let newItemsAnswr = {};
      const callreslt = true;
      if (callreslt === true) {
        handleresult(result, newItem);
      }

      for (const property in newElementsAnswr) {
        if (callreslt === true) {
          newItemsAnswr = handleitem(property, newItem, newItemsAnswr, result, newElementsAnswr);
        }
      }
      newItemsAnswr = samplefunction(productData, newItemsAnswr);
      setItemsAnswerSavings(newItemsAnswr);
    }
    if (
      (isBundle(productName) && productTabVal === 1) ||
      !isBundle(productName) ||
      productAccountType
    ) {
      const newElementsAnswer = { ...itemsAnswer, [newItem.name]: result };
      setItemsAnswer(newElementsAnswer);
      let newItemsAnswer = {};
      const callresult = true;
      if (callresult === true) {
        handleresult(result, newItem);
      }

      for (const property in newElementsAnswer) {
        if (callresult === true) {
          newItemsAnswer = handleitem(property, newItem, newItemsAnswer, result, newElementsAnswer);
        }
      }
      newItemsAnswer = samplefunction(productDataSavings, newItemsAnswer);
      setItemsAnswer(newItemsAnswer);
    }
  };

  const back = (e) => {
    e.preventDefault();
    if (isEtbFlow(leadGenerationContext)) {
      history.push({
        pathname: `/${location?.toLowerCase()}/${language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
          productName
        )}/login-address`,
      });
    } else if (
      businessMapping(productName) &&
      (productTypeMapping(productType) === 'Checking Account' ||
        productTypeMapping(productType) === 'Savings Account')
    ) {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/commercial-form/${productNameURLMapping(
          productName
        )}/document-checklist`
      );
    } else {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/compliance-info`
      );
    }
  };

  const saveData = async () => {
    const data = {};
    data.applicationId = leadGenerationContext.applicationId;
    data.language = leadGenerationContext.language;
    data.location = leadGenerationContext.location;
    data.productType = leadGenerationContext.productType;
    data.productName = leadGenerationContext.productName;
    data.utmCampaign = leadGenerationContext.utmCampaign;
    data.utmMedium = leadGenerationContext.utmMedium;
    data.utmContent = leadGenerationContext.utmContent;
    data.utmTerm = leadGenerationContext.utmTerm;
    data.utmSource = leadGenerationContext.utmSource;
    data.branchCode = leadGenerationContext.branchCode;
    data.itemsAnswer = leadGenerationContext.itemsAnswer;
    data.productData = leadGenerationContext.productData;
    data.productDataSavings = leadGenerationContext.productDataSavings;

    data.formAnswer = leadGenerationContext.formAnswer;
    data.debitCardFlag = leadGenerationContext.debitCardDisburse;
    data.depositeCardFlag = leadGenerationContext.depositeCardDisburse;
    data.countries = leadGenerationContext.countries;
    data.salesAdvisor = leadGenerationContext.salesAdvisor;
    data.customerType = leadGenerationContext.customerType;
    data.flowTypeETB = leadGenerationContext.flowTypeETB;
    data.customerAppId = leadGenerationContext.customerAppId;
    data.accruedInterestMethod = interestPaymentMethod?.accuredIntMethod;
    data.accountType = interestPaymentMethod?.typeOfAccount;
    data.accountNumber = interestPaymentMethod?.accountNumber;
    data.routingNumber =
      interestPaymentMethod?.transitNumber === 'Other'
        ? interestPaymentMethod?.customTransitNumber
        : interestPaymentMethod?.transitNumber;
    data.existingId = interestPaymentMethod?.Id;
    data.bank = interestPaymentMethod?.bank;
    data.otherBank = interestPaymentMethod?.otherBank;
    data.itemsAnswerSavings = leadGenerationContext.itemsAnswerSavings;
    data.formAnswerSavings = leadGenerationContext.formAnswerSavings;
    data.currentFlow = leadGenerationContext.currentFlow;
    data.productAccountType = leadGenerationContext.productAccountType;

    let response = null;
    setSavedItemsAnswer(leadGenerationContext.itemsAnswer);
    setSavedFormAnswer(leadGenerationContext.formAnswer);

    response = await saveProductInformation(data, accessToken);
    return response;
  };

  const ntbRouting = () => {
    if (
      businessMapping(productName) &&
      (productTypeMapping(productType) === 'Checking Account' ||
        productTypeMapping(productType) === 'Savings Account')
    ) {
      history.push(
        `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/commercial-form/${productNameURLMapping(
          productName
        )}/consent-info`
      );
    } else if (
      productMapping(productName) === PROGRESA_CONTIGO ||
      productName === 'Libre Account' ||
      productName === 'Cuenta Libre'
    ) {
      history?.push(
        `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/consent-info`
      );
    } else if (
      productMapping(productName) === ELITE_ACCOUNT_EN ||
      productMapping(productName) === 'Ahorra' ||
      productMapping(productName) === LIBRE_AHORRA_BUNDLE
    ) {
      history?.push(
        `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/feature-info`
      );
    } else {
      history?.push(
        `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/funding-info`
      );
    }
  };
  const nextPageRouting = () => {
    if (
      leadGenerationContext.flowTypeETB === 'EtbFlow' &&
      leadGenerationContext.customerType === 'ETB'
    ) {
      // next page
      if (
        productMapping(productName) === ELITE_ACCOUNT_EN ||
        productMapping(productName) === 'Ahorra' ||
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
      ) {
        history?.push(
          `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
            productName
          )}/feature-info`
        );
      } else if (isCDproduct(productName) || isCDIraproduct(productName)) {
        history?.push(
          `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
            productName
          )}/funding-info`
        );
      } else {
        history.push({
          pathname: `/${location?.toLowerCase()}/${language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
            productName
          )}/consent-info`,
        });
      }
    } else {
      ntbRouting();
    }
  };
  const checkInternationalTransfer = (itemsAnswers) => {
    let validInternationalTransfer = true;
    if (
      businessMapping(productName) &&
      (productTypeMapping(productType) === 'Checking Account' ||
        productTypeMapping(productType) === 'Savings Account')
    ) {
      if (itemsAnswers?.InternationalWireTransfer) {
        if (leadGenerationContext.countries.length > 0) {
          setInternationalWireTransferError('');
        } else {
          validInternationalTransfer = false;
          setInternationalWireTransferError('* Mandatory Field');
        }
      }
    }
    return validInternationalTransfer;
  };

  // const handleBundleTabError = async () => {
  //   const data = {
  //     productName: leadGenerationContext.productName,
  //     productType: leadGenerationContext.productType,
  //     countries: leadGenerationContext.countries,
  //   };
  //   const act22DocID = null;
  //   const questionAndAnswers = getQuestionAndAnswers(
  //     productData.questions,
  //     itemsAnswer,
  //     formAnswer,
  //     act22DocID,
  //     data
  //   );
  //   const questionAndAnswersSavings = getQuestionAndAnswers(
  //     productData.questions,
  //     itemsAnswerSavings,
  //     formAnswerSavings,
  //     act22DocID,
  //     data
  //   );

  //   const product = [
  //     {
  //       ProductType: 'Savings Account',
  //       ProductName: productMapping(data.productName),
  //       Questions: questionAndAnswersSavings,
  //       Category: 'Secondary',
  //     },
  //     {
  //       ProductType: 'Checking Account',
  //       ProductName: productMapping(data.productName),
  //       Questions: questionAndAnswers,
  //       Category: 'Primary',
  //     },
  //   ];

  //   for (const prod of product) {
  //     const prodType = prod.ProductType;
  //     const hasValidFormData = prod.Questions.some(
  //       (q) => q.FormData && Object.keys(q.FormData).length === 2
  //     );

  //     if (!hasValidFormData) {
  //       const tab = prodType === 'Checking Account' ? 1 : prodType === 'Savings Account' ? 0 : null;
  //       setProductTabVal(tab);
  //       return hasValidFormData;
  //     }
  //   }
  // };

  const handleTabChange = () => {
    let valid = true;
    if (isBundle(productName) && !productAccountType) {
      if (
        productTabVal === 0 &&
        // Object.keys(leadGenerationContext?.itemsAnswerSavings || {})?.length === 0
        (Object.values(leadGenerationContext?.itemsAnswerSavings).every(
          (value) => value === '' || value === false || value === undefined
        ) ||
          Object.values(formAnswerSavings).some((value) => value.toLowerCase().includes('select')))
      ) {
        setProductTabVal(0);
        valid = false;
      } else if (
        productTabVal === 0 &&
        // Object.keys(leadGenerationContext?.itemsAnswer || {})?.length === 0
        (Object.values(leadGenerationContext?.itemsAnswer).every(
          (value) => value === '' || value === false || value === undefined
        ) ||
          Object.values(formAnswer).some((value) => value.toLowerCase().includes('select')))
      ) {
        setProductTabVal(1);
        valid = false;
      } else if (
        productTabVal === 1 &&
        // Object.keys(leadGenerationContext?.itemsAnswer || {})?.length === 0
        (Object.values(leadGenerationContext?.itemsAnswer).every(
          (value) => value === '' || value === false || value === undefined
        ) ||
          Object.values(formAnswer).some((value) => value.toLowerCase().includes('select')))
      ) {
        valid = false;
        setProductTabVal(1);
      } else if (
        productTabVal === 1 &&
        // Object.keys(leadGenerationContext?.itemsAnswerSavings || {})?.length === 0

        (Object.values(leadGenerationContext?.itemsAnswerSavings).every(
          (value) => value === '' || value === false || value === undefined
        ) ||
          Object.values(formAnswerSavings).some((value) => value.toLowerCase().includes('select')))
      ) {
        valid = false;
        setProductTabVal(0);
      }
    }
    return valid;
  };

  const continueStep = async (e) => {
    e.preventDefault();
    setIsValidating(true);

    const questions = productData?.questions ? productData.questions : {};
    let valid = true;
    const problmaticBox = [];
    const unProblmaticBox = [];
    const problematicBox = [];
    const unProblematicBox = [];
    let problematicQuestion = '';
    let problmaticQustion = '';

    if (
      Object.keys(leadGenerationContext.formAnswerSavings ?? {}).length === 0 &&
      !productAccountType
    ) {
      setLibreAccountError(true);
    } else {
      setLibreAccountError(false);
    }
    if (Object.keys(leadGenerationContext.formAnswer ?? {}).length === 0 && !productAccountType) {
      setAhorraAccountError(true);
    } else {
      setAhorraAccountError(false);
    }
    if (Object.keys(leadGenerationContext.formAnswer ?? {}).length === 0 && productAccountType) {
      setCommonAccountError(true);
    } else {
      setCommonAccountError(false);
    }

    if (isBundle(productName) && leadGenerationContext.productTabVal === 0 && !productAccountType) {
      const itemsAnswerSaving = { ...leadGenerationContext.itemsAnswerSavings };
      const formAnswerSaving = { ...leadGenerationContext.formAnswerSavings };

      let previousQues = '';
      valid = checkInternationalTransfer(itemsAnswerSaving);
      for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        if (question?.type === 'Form' && previousQues === '') {
          previousQues = questions[i - 1]?.name;
        }
        if (question?.type !== 'Form') {
          if (question?.required) {
            if (question?.type !== 'IRA') {
              if (question.type !== 'Interest' && question.type !== 'Grouped') {
                if (itemsAnswerSaving[question.name] === true) {
                  valid = false;
                  problmaticQustion = question.name;
                  break;
                }
              } else if (question.type === 'Grouped') {
                if (!itemsAnswerSaving[question.name]) {
                  valid = false;
                  problmaticQustion = question.name;
                  break;
                }
              }
            } else if (Object.prototype.hasOwnProperty.call(itemsAnswerSaving, question.name)) {
              if (
                itemsAnswerSaving[question.name] === '' ||
                itemsAnswerSaving[question.name] === 'Select...' ||
                itemsAnswerSaving[question.name] === 'Select Withdraw $' ||
                itemsAnswerSaving[question.name] === 'Select Deposits $' ||
                itemsAnswerSaving[question.name] === false
              ) {
                valid = false;
                problmaticQustion = question.name;
                if (question.next) {
                  const { components } = question.next[0];
                  if (components.length > 0) {
                    problmaticBox.push(`${question.name}_${components[0].label}`);
                  }
                }
                break;
              } else if (question.next) {
                const { components } = question.next[0];
                if (components.length > 0) {
                  unProblmaticBox.push(`${question.name}_${components[0].label}`);
                }
              }
            } else {
              valid = false;
              problmaticQustion = question.name;
              if (question.next) {
                const { components } = question.next[0];
                if (components.length > 0) {
                  problmaticBox.push(`${question.name}_${components[0].label}`);
                }
              }
              break;
            }
          }
        } else if (itemsAnswerSaving[question.name] === true) {
          if (Object.keys(formAnswerSaving).length === 0) {
            valid = false;
            problmaticQustion = question.name;
            for (const elementQue of question.next) {
              let components = [];
              if (elementQue.components) {
                const componentValues = elementQue.components;
                components = componentValues;
              }
              for (const element of components) {
                const component = element;
                if (component.type !== 'image') {
                  const property = `${previousQues}_${question.name}_${component.label}`;
                  problmaticBox.push(property);
                }
              }
            }
          } else {
            for (const element of question.next) {
              let components = [];
              if (element.components) {
                const componentValues = element.components;
                components = componentValues;
              }
              for (const elementcomponent of components) {
                const component = elementcomponent;
                if (component.type !== 'image') {
                  const property = `${question.name}_${component.label}`;
                  const probProperty = `${previousQues}_${question.name}_${component.label}`;
                  if (Object.prototype.hasOwnProperty.call(formAnswerSaving, property)) {
                    if (
                      formAnswerSaving[property] === '' ||
                      formAnswerSaving[property] === 'Select...' ||
                      formAnswerSaving[property] === 'Select Withdraw $' ||
                      formAnswerSaving[property] === 'Select Deposits $'
                    ) {
                      valid = false;
                      problmaticQustion = question.name;
                      problmaticBox.push(probProperty);
                    } else {
                      if (component.subComponents) {
                        const { subComponents } = component;
                        for (const elementSubComp of subComponents) {
                          const subProperty = `${question.name}_${component.label}_${elementSubComp.label}`;
                          if (Object.prototype.hasOwnProperty.call(formAnswerSaving, subProperty)) {
                            if (
                              formAnswerSaving[subProperty] === '' ||
                              formAnswerSaving[property] === 'Select...' ||
                              formAnswerSaving[property] === 'Select Withdraw $' ||
                              formAnswerSaving[property] === 'Select Deposits $'
                            ) {
                              valid = false;
                              problmaticBox.push(`${previousQues}_${subProperty}`);
                            } else {
                              unProblmaticBox.push(`${previousQues}_${subProperty}`);
                            }
                          } else {
                            valid = false;
                            problmaticBox.push(`${previousQues}_${subProperty}`);
                          }
                        }
                      }
                      unProblmaticBox.push(probProperty);
                    }
                  } else {
                    valid = false;
                    problmaticQustion = question.name;
                    problmaticBox.push(probProperty);
                  }
                }
              }
            }
          }
        }
      }
      if (problmaticQustion !== 'MontlyExpectedTransactions') {
        const element = document.getElementById('MontlyExpectedTransactions');
        if (element) {
          element.style.borderColor = '#FFFFFF';
        }
      }
    } else if (
      (isBundle(productName) && leadGenerationContext.productTabVal === 1) ||
      !isBundle(productName) ||
      productAccountType
    ) {
      const itemAnswers = { ...leadGenerationContext.itemsAnswer };
      const formAnswers = { ...leadGenerationContext.formAnswer };

      let prevQues = '';

      valid = checkInternationalTransfer(itemAnswers);
      for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        if (question?.type === 'Form' && prevQues === '') {
          prevQues = questions[i - 1]?.name;
        }
        if (question?.type !== 'Form') {
          if (question?.required) {
            if (question?.type !== 'IRA') {
              if (question.type !== 'Interest' && question.type !== 'Grouped') {
                if (itemAnswers[question.name] === true) {
                  valid = false;
                  problematicQuestion = question.name;
                  break;
                }
              } else if (question.type === 'Grouped') {
                if (!itemAnswers[question.name]) {
                  valid = false;
                  problematicQuestion = question.name;
                  break;
                }
              }
            } else if (Object.prototype.hasOwnProperty.call(itemAnswers, question.name)) {
              if (
                itemAnswers[question.name] === '' ||
                itemAnswers[question.name] === 'Select...' ||
                itemAnswers[question.name] === 'Select Withdraw $' ||
                itemAnswers[question.name] === 'Select Deposits $' ||
                itemAnswers[question.name] === false
              ) {
                valid = false;
                problematicQuestion = question.name;
                if (question.next) {
                  const { components } = question.next[0];
                  if (components.length > 0) {
                    problematicBox.push(`${question.name}_${components[0].label}`);
                  }
                }
                break;
              } else if (question.next) {
                const { components } = question.next[0];
                if (components.length > 0) {
                  unProblematicBox.push(`${question.name}_${components[0].label}`);
                }
              }
            } else {
              valid = false;
              problematicQuestion = question.name;
              if (question.next) {
                const { components } = question.next[0];
                if (components.length > 0) {
                  problematicBox.push(`${question.name}_${components[0].label}`);
                }
              }
              break;
            }
          }
        } else if (itemAnswers[question.name] === true) {
          if (Object.keys(formAnswers).length === 0) {
            valid = false;
            problematicQuestion = question.name;
            for (const elementQue of question.next) {
              let components = [];
              if (elementQue.components) {
                const componentValues = elementQue.components;
                components = componentValues;
              }
              for (const element of components) {
                const component = element;
                if (component.type !== 'image') {
                  const property = `${prevQues}_${question.name}_${component.label}`;
                  problematicBox.push(property);
                }
              }
            }
          } else {
            for (const element of question.next) {
              let components = [];
              if (element.components) {
                const componentValues = element.components;
                components = componentValues;
              }
              for (const elementcomponent of components) {
                const component = elementcomponent;
                if (component.type !== 'image') {
                  const property = `${question.name}_${component.label}`;
                  const probProperty = `${prevQues}_${question.name}_${component.label}`;
                  if (Object.prototype.hasOwnProperty.call(formAnswers, property)) {
                    if (
                      formAnswers[property] === '' ||
                      formAnswers[property] === 'Select...' ||
                      formAnswers[property] === 'Select Withdraw $' ||
                      formAnswers[property] === 'Select Deposits $'
                    ) {
                      valid = false;
                      problematicQuestion = question.name;
                      problematicBox.push(probProperty);
                    } else {
                      if (component.subComponents) {
                        const { subComponents } = component;
                        for (const elementSubComp of subComponents) {
                          const subProperty = `${question.name}_${component.label}_${elementSubComp.label}`;
                          if (Object.prototype.hasOwnProperty.call(formAnswers, subProperty)) {
                            if (
                              formAnswers[subProperty] === '' ||
                              formAnswers[property] === 'Select...' ||
                              formAnswers[property] === 'Select Withdraw $' ||
                              formAnswers[property] === 'Select Deposits $'
                            ) {
                              valid = false;
                              problematicBox.push(`${prevQues}_${subProperty}`);
                            } else {
                              unProblematicBox.push(`${prevQues}_${subProperty}`);
                            }
                          } else {
                            valid = false;
                            problematicBox.push(`${prevQues}_${subProperty}`);
                          }
                        }
                      }
                      unProblematicBox.push(probProperty);
                    }
                  } else {
                    valid = false;
                    problematicQuestion = question.name;
                    problematicBox.push(probProperty);
                  }
                }
              }
            }
          }
        }
      }
      if (problematicQuestion !== 'MontlyExpectedTransactions') {
        const element = document.getElementById('MontlyExpectedTransactions');
        if (element) {
          element.style.borderColor = '#FFFFFF';
        }
      }
    }

    const isFormValid = () => {
      if (isCDproduct(productName)) {
        // accuredIntMethod accountNumberOriental typeOfAccount routingNumber

        if (!interestPaymentMethod?.accuredIntMethod) {
          valid = false;
          setInterestPaymentMethodErr((prevState) => ({
            ...prevState,
            accuredIntMethod: MANDATORY_FIELD_ERR,
          }));
        }
        if (
          !interestPaymentMethod?.accountNumberOriental &&
          interestPaymentMethod?.accuredIntMethod === 'Deposit interest in Oriental account'
        ) {
          valid = false;
          setInterestPaymentMethodErr((prevState) => ({
            ...prevState,
            accountNumberOriental: MANDATORY_FIELD_ERR,
          }));
        }
        if (
          !interestPaymentMethod?.typeOfAccount &&
          interestPaymentMethod?.accuredIntMethod === 'Deposit interest in external account'
        ) {
          valid = false;
          setInterestPaymentMethodErr((prevState) => ({
            ...prevState,
            typeOfAccount: MANDATORY_FIELD_ERR,
          }));
        }
        if (
          !interestPaymentMethod?.accountNumber &&
          interestPaymentMethod?.accuredIntMethod === 'Deposit interest in external account'
        ) {
          valid = false;
          setInterestPaymentMethodErr((prevState) => ({
            ...prevState,
            accountNumber: MANDATORY_FIELD_ERR,
          }));
        }

        if (interestPaymentMethod?.accuredIntMethod?.includes('external')) {
          if (!interestPaymentMethod?.bank) {
            valid = false;

            leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
              ...prevState,

              bank: MANDATORY_FIELD_ERR,
            }));
          }
          if (interestPaymentMethod?.bank === 'Other') {
            if (!interestPaymentMethod.otherBank) {
              valid = false;
              leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
                ...prevState,
                otherBank: MANDATORY_FIELD_ERR,
              }));
            }
          }
          if (interestPaymentMethod?.transitNumber === 'Other') {
            if (!interestPaymentMethod?.customTransitNumber) {
              valid = false;
              leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
                ...prevState,
                customTransitNumber: MANDATORY_FIELD_ERR,
              }));
            }
          } else if (!interestPaymentMethod?.transitNumber) {
            valid = false;

            leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
              ...prevState,

              transitNumber: MANDATORY_FIELD_ERR,
            }));
          }
        }

        for (const key in interestPaymentMethodErr) {
          if (interestPaymentMethodErr[key]) {
            valid = false;
            break;
          }
        }
      }
      return valid;
    };
    const formValid = isFormValid();

    // const hasErrors = interestPaymentMethodErr
    //   ? Object?.values(interestPaymentMethodErr).some((err) => err !== '')
    //   : false;

    // Libre Ahorra tab validation

    valid = handleTabChange();

    if (valid && formValid) {
      if (isScreenFiveDirty || isCommercialProductUIDirty) {
        const result = await saveData();
        if (result && result.status === 201) {
          setIsScreenFiveDirty(false);
          setIsCommercialProductUIDirty(false);
          setIsValidating(false);
          nextPageRouting();
        }
      } else {
        setIsValidating(false);
        nextPageRouting();
      }
    } else {
      if (isBundle(productName)) {
        if (problmaticQustion !== '' && problmaticQustion !== 'IRAType') {
          const element = document.getElementById(problmaticQustion);
          if (element) {
            element.style.borderColor = '#FD0000';
            if (isSm) {
              element.style.padding = '5px';
            }
          }
          if (problmaticQustion === 'MontlyExpectedTransactions') {
            const transactionElement = document.getElementById('CashTransaction');
            if (transactionElement) {
              transactionElement.focus();
            }
          }
        }
        if (problmaticBox.length > 0) {
          const problematicSubQuestion = problmaticBox[0];
          const probQuestion = problematicSubQuestion.split('_')[0];
          const parentElement = document.getElementById(probQuestion);
          if (parentElement && probQuestion !== 'IRAType') {
            parentElement.style.borderColor = '#FFFFFF';
          }
          for (const probmaticBox of problmaticBox) {
            const errorSpan = document.getElementById(`${probmaticBox}_errorSpan`);
            if (errorSpan) {
              errorSpan.style.display = 'block';
            }
          }
          for (const field of problmaticBox) {
            const element = document.getElementById(field);
            if (element) {
              element.focus();
              break;
            }
          }
        }
        if (unProblmaticBox.length > 0) {
          for (const unproblmaticBox of unProblmaticBox) {
            const errorSpan = document.getElementById(`${unproblmaticBox}_errorSpan`);
            if (errorSpan) {
              errorSpan.style.display = 'none';
            }
          }
        }
      }
      if (problematicQuestion !== '' && problematicQuestion !== 'IRAType') {
        const element = document.getElementById(problematicQuestion);
        if (element) {
          element.style.borderColor = '#FD0000';
          if (isSm) {
            element.style.padding = '5px';
          }
        }
        if (problematicQuestion === 'MontlyExpectedTransactions') {
          const transactionElement = document.getElementById('CashTransaction');
          if (transactionElement) {
            transactionElement.focus();
          }
        }
      }
      if (problematicBox.length > 0) {
        const problematicSubQuestion = problematicBox[0];
        const probQuestion = problematicSubQuestion.split('_')[0];
        const parentElement = document.getElementById(probQuestion);
        if (parentElement && probQuestion !== 'IRAType') {
          parentElement.style.borderColor = '#FFFFFF';
        }
        for (const problematicbox of problematicBox) {
          const errorSpan = document.getElementById(`${problematicbox}_errorSpan`);
          if (errorSpan) {
            errorSpan.style.display = 'block';
          }
        }
        for (const field of problematicBox) {
          const element = document.getElementById(field);
          if (element) {
            element.focus();
            break;
          }
        }
      }
      if (unProblematicBox.length > 0) {
        for (const unproblematicbox of unProblematicBox) {
          const errorSpan = document.getElementById(`${unproblematicbox}_errorSpan`);
          if (errorSpan) {
            errorSpan.style.display = 'none';
          }
        }
      }
    }
    setIsValidating(false);
  };

  const handleDebitCardRequiredRadio = (e) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);

    if (isBundle(productName)) {
      setDebitCardDisburse(!debitCardDisburse);
    } else if (e.target.checked === true) {
      setDebitCardNotRequired(false);
      setDebitCardDisburse(true);
    } else {
      setDebitCardDisburse(false);
    }
  };
  const handleDebitCardRequiredRadioOnEnter = (e) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      if (isBundle(productName)) {
        setDebitCardDisburse(!debitCardDisburse);
        setDebitCardNotRequired(!debitCardNotRequired);
      } else {
        setDebitCardNotRequired(false);
        setDebitCardDisburse(true);
      }
    }
  };
  const handleDebitCardNotReqRadio = (e) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.target.checked === true) {
      setDebitCardNotRequired(true);
      setDebitCardDisburse(false);
    } else {
      setDebitCardNotRequired(false);
    }
  };
  const handleDebitCardNotReqRadioOnEnter = (e) => {
    if (
      businessMapping(leadGenerationContext.productName) &&
      (productTypeMapping(leadGenerationContext.productType) === 'Checking Account' ||
        productTypeMapping(leadGenerationContext.productType) === 'Savings Account')
    ) {
      leadGenerationContext.setIsCommercialProductUIDirty(true);
    }
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      setDebitCardNotRequired(true);
      setDebitCardDisburse(false);
    }
  };
  // debit card change
  const handleDepositeCardRequiredRadio = (e) => {
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    setDepositeCardDisburse(e.target.value);
  };
  const handleDepositeCardRequiredRadioOnEnter = (e) => {
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      setDepositeCardDisburse(e.target.value);
    }
  };
  /**
   * Handle Save Application button: Should be navigated to Save Application Page */
  const handleSaveApplication = (e) => {
    e.preventDefault();
    setIsModalSaveLater(true);
  };

  const accuredIntMethodCall = (e) => {
    if (e.target.value.length > 0) {
      setInterestPaymentMethod((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setInterestPaymentMethodErr((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
      if (e.target.value === 'Deposit interest in this CD') {
        setInterestPaymentMethod((prevState) => ({
          ...prevState,
          Id: '',
          accountNumber: '',
          transitNumber: '',
          customTransitNumber: '',
          bank: '',
          otherBank: '',
          typeOfAccount: '',
          accountNumberOriental: '',
        }));
        setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          accountNumber: '',
          transitNumber: '',
          customTransitNumber: '',
          bank: '',
          otherBank: '',
          typeOfAccount: '',
          accountNumberOriental: '',
        }));
      }
      if (e.target.value === 'Deposit interest in Oriental account') {
        setInterestPaymentMethod((prevState) => ({
          ...prevState,
          Id: '',
          accountNumber: '',
          transitNumber: '',
          customTransitNumber: '',
          bank: '',
          otherBank: '',
          typeOfAccount: '',
          accountNumberOriental: '',
        }));
        setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          accountNumber: '',
          transitNumber: '',
          typeOfAccount: '',
          customTransitNumber: '',
          bank: '',
          otherBank: '',
          // accountNumberOriental: '',
        }));
      }
      if (e.target.value === 'Deposit interest in external account') {
        setInterestPaymentMethod((prevState) => ({
          ...prevState,
          accountNumber: '',
          typeOfAccount: '',
          transitNumber: '',
          customTransitNumber: '',
          bank: '',
          otherBank: '',
          accountNumberOriental: '',
          Id: '',
        }));
        setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          accountNumber: '',
          typeOfAccount: '',
          transitNumber: '',
          customTransitNumber: '',
          bank: '',
          otherBank: '',
          accountNumberOriental: '',
        }));
      }
    } else {
      setInterestPaymentMethod((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setInterestPaymentMethodErr((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const accountNumberCall = (e) => {
    const conditionAccNoSelect = isPlaidProduct(productName)
      ? e.target.value.length >= 9 && e.target.value.length <= 17
      : e.target.value.length >= 9 && e.target.value.length <= 16;
    if (e.target?.value?.match(/^\d*$/)) {
      if (conditionAccNoSelect) {
        setInterestPaymentMethod((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value,
        }));
        setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          [e.target.name]: '',
        }));
        if (e.target.value.match(/^0*$/g)) {
          setInterestPaymentMethod((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
          setInterestPaymentMethodErr((prevState) => ({
            ...prevState,
            [e.target.name]: '* Invalid Account Number',
          }));
        }
      } else {
        setInterestPaymentMethod((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value,
        }));
        setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          [e.target.name]: INVALID_FORMAT_ERR,
        }));
      }
    } else if (e.target.value === '') {
      setInterestPaymentMethod((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setInterestPaymentMethodErr((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };

  const getAccontNoById = (e) => {
    const selectedAccount = accNoListForOrientalAccount?.find((account) => account.Id === e);
    return selectedAccount || null;
  };

  const accountNumberSelect = (e) => {
    if (e.target.value) {
      setSelectedOrientalAccountProgress(getAccontNoById(e.target.value));
      setInterestPaymentMethod((prevState) => ({
        ...prevState,
        [e.target.name]: getAccontNoById(e.target.value).AccountNumber,
        Id: e.target.value,
      }));

      setInterestPaymentMethodErr((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
    } else if (e.target.value === '') {
      setInterestPaymentMethod((prevState) => ({ ...prevState, [e.target.name]: '', Id: '' }));
      setInterestPaymentMethodErr((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
        id: '',
      }));
    }
  };

  const handleBlurRouting = (e) => {
    const numberString = e.target.value.toString();
    if (
      (e.target.value >= 1 || interestPaymentMethod?.transitNumber.length >= 1) &&
      interestPaymentMethod?.bank === OTHER &&
      interestPaymentMethod?.transitNumber !== OTHER
    ) {
      leadGenerationContext.setInterestPaymentMethod((prevState) => ({
        ...prevState,
        transitNumber: numberString.padStart(9, '0'),
      }));
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setInterestPaymentMethod((prevState) => ({
          ...prevState,
          transitNumber: numberString,
        }));
        leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          transitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setInterestPaymentMethod((prevState) => ({
          ...prevState,
          transitNumber: numberString.padStart(9, '0'),
        }));
        leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    } else if (
      (e.target.value >= 1 || interestPaymentMethod?.customTransitNumber?.length >= 1) &&
      interestPaymentMethod?.transitNumber === OTHER
    ) {
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setInterestPaymentMethod((prevState) => ({
          ...prevState,
          customTransitNumber: numberString,
        }));
        leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          customTransitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setInterestPaymentMethod((prevState) => ({
          ...prevState,
          customTransitNumber: numberString.padStart(9, '0'),
        }));
        leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          customTransitNumber: '',
        }));
      }
    }
  };

  const bankDetailsChange = (e) => {
    if (bankDetails && bankDetails?.length > 0) {
      let bank = '';
      for (const element of bankDetails) {
        if (element.bankName === e.target.value) {
          bank = element;
          break;
        }
      }
      bankTransitNumbersChange(bank);
    }
  };

  const bankTransitNumbersChange = (bank) => {
    if (bank?.transistNumbers) {
      const transitNumbers = bank?.transistNumbers;
      if (!transitNumbers?.includes('Other')) {
        transitNumbers.push('Other');
      }
      if (transitNumbers && transitNumbers?.length > 0) {
        setBankTransitNumbers(transitNumbers);
        if (transitNumbers.length === 1 && transitNumbers[0] !== OTHER) {
          setInterestPaymentMethod((prevState) => ({
            ...prevState,
            transitNumber: transitNumbers[0],
          }));
          setInterestPaymentMethodErr((prevState) => ({
            ...prevState,
            transitNumber: '',
          }));
        } else {
          setInterestPaymentMethod((prevState) => ({
            ...prevState,
            transitNumber: '',
          }));
          setInterestPaymentMethodErr((prevState) => ({
            ...prevState,
            transitNumber: '',
          }));
        }
      } else {
        setBankTransitNumbers([]);
        setInterestPaymentMethod((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
        setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    } else {
      setBankTransitNumbers([]);
      setInterestPaymentMethod((prevState) => ({ ...prevState, transitNumber: '' }));
      setInterestPaymentMethodErr((prevState) => ({
        ...prevState,
        transitNumber: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const transitNumberChange = (e) => {
    if (
      // /^0+$/.test(e.target.value) &&
      interestPaymentMethod?.bank === OTHER &&
      e.target.name === 'transitNumber' &&
      e.target.value.length >= 1 &&
      e.target.value.match(/^\d*$/)
    ) {
      leadGenerationContext.setInterestPaymentMethod((prevState) => ({
        ...prevState,
        transitNumber: e.target.value,
      }));
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          transitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    } else if (
      interestPaymentMethod?.bank !== OTHER &&
      e.target.name === 'transitNumber' &&
      e.target.value.length >= 1
      // e.target.value.match(/^\d*$/)
    ) {
      leadGenerationContext.setInterestPaymentMethod((prevState) => ({
        ...prevState,
        transitNumber: e.target.value,
      }));
      leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
        ...prevState,
        transitNumber: '',
      }));
      leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
        ...prevState,
        customTransitNumber: '',
      }));
      leadGenerationContext.setInterestPaymentMethod((prevState) => ({
        ...prevState,
        customTransitNumber: '',
      }));
    } else if (
      interestPaymentMethod?.transitNumber === OTHER &&
      e.target.name === 'customTransitNumber' &&
      e.target.value.length >= 1 &&
      e.target.value.match(/^\d*$/)
    ) {
      leadGenerationContext.setInterestPaymentMethod((prevState) => ({
        ...prevState,
        customTransitNumber: e.target.value,
      }));
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          customTransitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
          ...prevState,
          customTransitNumber: '',
        }));
      }
    } else if (e.target.value === '') {
      leadGenerationContext.setInterestPaymentMethodErr((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
      leadGenerationContext.setInterestPaymentMethod((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const handleChangeIntrstPayment = (e) => {
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    switch (e.target.name) {
      case 'accuredIntMethod':
      case 'typeOfAccount':
        accuredIntMethodCall(e);
        break;
      case 'accountNumberOriental':
        accountNumberSelect(e);
        break;
      case 'accountNumber':
        accountNumberCall(e);

        break;
      case 'bank':
        if (e.target.value.length > 0) {
          if (e.target.value !== OTHER) {
            setInterestPaymentMethod((prevState) => ({
              ...prevState,
              otherBank: '',
            }));
            setInterestPaymentMethodErr((prevState) => ({
              ...prevState,
              otherBank: '',
            }));
          }
          setInterestPaymentMethod((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
            transitNumber: '',
            customTransitNumber: '',
          }));
          setInterestPaymentMethodErr((prevState) => ({
            ...prevState,
            [e.target.name]: '',
            transitNumber: '',
            customTransitNumber: '',
          }));
          bankDetailsChange(e);
        }
        break;
      case 'otherBank':
        if (e.target.value) {
          const regex = /^[ a-zA-Z0-9.,&-]{1,30}$/;
          setInterestPaymentMethod((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
          if (e.target.value.match(regex)) {
            setInterestPaymentMethodErr((prevState) => ({
              ...prevState,
              [e.target.name]: '',
            }));
          } else {
            setInterestPaymentMethodErr((prevState) => ({
              ...prevState,
              [e.target.name]: '* Invalid format',
            }));
          }
        } else if (e.target.value === '') {
          setInterestPaymentMethod((prevState) => ({ ...prevState, [e.target.name]: '' }));
          setInterestPaymentMethodErr((prevState) => ({
            ...prevState,
            [e.target.name]: MANDATORY_FIELD_ERR,
          }));
        }
        break;

      case 'transitNumber':
        transitNumberChange(e);
        break;
      case 'customTransitNumber':
        transitNumberChange(e);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (savedDataFlow && isBundle(productName)) {
      leadGenerationContext?.setItemsAnswer(leadGenerationContext?.savedItemsAnswer);
      leadGenerationContext?.setItemsAnswerSavings(leadGenerationContext?.savedItemsAnswerSavings);
    }
  }, [savedDataFlow]);

  const cdIraContinueStep = async () => {
    let valid = true;
    const contributionLimits = {
      priorTaxYear: 7000,
      currentTaxYear: 7500,
    };
    if (!leadGenerationContext.productDataIRA.yearStatus) {
      valid = false;
      setProductDataIRAErrors((prevState) => ({
        ...prevState,
        yearStatus: MANDATORY_FIELD_ERR,
      }));
    }

    if (
      isBtwAprilAndDecember &&
      !leadGenerationContext.productDataIRA.document &&
      leadGenerationContext.productDataIRA?.yearStatus?.id === 'priorTaxYear'
    ) {
      valid = false;
      setProductDataIRAErrors((prevState) => ({
        ...prevState,
        document: MANDATORY_FIELD_ERR,
      }));
    } else {
      setProductDataIRAErrors((prevState) => ({
        ...prevState,
        document: '',
      }));
    }
    if (!leadGenerationContext?.productDataIRA?.depositAmount) {
      valid = false;
      setProductDataIRAErrors((prevState) => ({
        ...prevState,
        depositAmount: MANDATORY_FIELD_ERR,
      }));
    }
    if (
      parseFloat(
        leadGenerationContext?.productDataIRA?.depositAmount.toString().replace(/[^\w\s]/gi, '')
      ) < 250.0
    ) {
      valid = false;
      setProductDataIRAErrors((prevState) => ({
        ...prevState,
        depositAmount: 'A minimum deposit of $250 is required to open this account.',
      }));
    }
    const deposit = parseFloat(
      leadGenerationContext?.productDataIRA?.depositAmount?.toString().replace(/[^\d.]/g, '')
    );
    const yearStatus = leadGenerationContext?.productDataIRA?.yearStatus?.id;
    if (yearStatus && deposit > contributionLimits[yearStatus]) {
      valid = false;
    }
    if (flowTypeETB === 'EtbFlow') {
      if (!leadGenerationContext?.productDataIRA?.depositAmount) {
        valid = false;
        setProductDataIRAErrors((prevState) => ({
          ...prevState,
          depositAmount: MANDATORY_FIELD_ERR,
        }));
      }
      if (
        parseFloat(
          leadGenerationContext?.productDataIRA?.depositAmount?.toString().replace(/[^\w\s]/gi, '')
        ) < 250.0
      ) {
        valid = false;
        setProductDataIRAErrors((prevState) => ({
          ...prevState,
          depositAmount: 'A minimum deposit of $250 is required to open this account.',
        }));
      } else if (leadGenerationContext?.productDataIRA?.depositAmount) {
        setProductDataIRAErrors((prevState) => ({
          ...prevState,
          depositAmount: '',
        }));
      }
      if (
        leadGenerationContext.productDataIRA.remainingContribution < 0 ||
        leadGenerationContext.productDataIRA.knockOFf
      ) {
        valid = false;
      }
    }

    if (valid) {
      setIsValidating(true);
      const data = {};
      data.applicationId = leadGenerationContext.applicationId;
      data.language = leadGenerationContext.language;
      data.location = leadGenerationContext.location;
      data.productType = leadGenerationContext.productType;
      data.productName = leadGenerationContext.productName;
      data.utmCampaign = leadGenerationContext.utmCampaign;
      data.utmMedium = leadGenerationContext.utmMedium;
      data.utmContent = leadGenerationContext.utmContent;
      data.utmTerm = leadGenerationContext.utmTerm;
      data.utmSource = leadGenerationContext.utmSource;
      data.branchCode = leadGenerationContext.branchCode;
      data.taxExtensionDocID = leadGenerationContext.productDataIRA.document;

      data.customerAppId = leadGenerationContext.customerAppId;
      data.accruedInterestMethod = interestPaymentMethod?.accuredIntMethod;
      data.contributionYear = leadGenerationContext.productDataIRA.yearStatus.text;
      data.depositAmount = leadGenerationContext.productDataIRA?.depositAmount?.replace(/,/g, '');

      let response = null;
      setFundData({
        ...fundData,
        depositAmount: leadGenerationContext.productDataIRA?.depositAmount?.replace(/,/g, ''),
      });
      response = await saveProductInformation(data, accessToken);

      if (response && response.status === 201) {
        setIsScreenFiveDirty(false);
        setIsCommercialProductUIDirty(false);
        setIsValidating(false);
        nextPageRouting();
      } else {
        setIsValidating(false);
      }
    }
  };

  const ProductIndexFunc = () =>
    productData?.questions?.length && !isValidating > 0
      ? productData.questions.map((item) => (
          <Grid container key={item?.name}>
            <ProductIndex
              item={item}
              disable={false}
              setItemsAnswer={setItemsAnswer}
              itemsHandler={itemsHandler}
              itemsAnswer={itemsAnswer}
              productData={productData}
              savedDataFlow={savedDataFlow}
              savedItemsAnswer={savedItemsAnswer}
              currentPage={leadGenerationContext.currentPage}
              productName={productName}
              commonAccountError={commonAccountError}
              ahorraAccountError={ahorraAccountError}
              productTabVal={productTabVal}
            />
          </Grid>
        ))
      : '';
  const ProductIndexFuncSavings = () =>
    productDataSavings?.questions?.length && !isValidating > 0
      ? productDataSavings.questions.map((item) => (
          <Grid container key={item?.name}>
            <ProductIndex
              item={item}
              disable={false}
              setItemsAnswer={setItemsAnswerSavings}
              itemsHandler={itemsHandler}
              itemsAnswer={itemsAnswerSavings}
              productData={productDataSavings}
              savedDataFlow={savedDataFlow}
              savedItemsAnswer={savedItemsAnswerSavings}
              currentPage={leadGenerationContext.currentPage}
              productName={productName}
              libreAccountError={libreAccountError}
              productTabVal={productTabVal}
            />
          </Grid>
        ))
      : '';
  // <div className="consent-loader-style">
  //   <Loader />
  // </div>
  const oldLayout = () => (
    <Layout
      ariaDescribedby="screenFiveHeading"
      headingId="screenFiveHeading"
      ariaDescribedbyId="screenFiveDesc"
      classes={styledClasses}
      descriptionKey={
        productMapping(productName) === 'Elite Account'
          ? 'Product Page Text Prog'
          : PRODUCTUI_PAGE_KEY
      }
      descriptionValue={PRODUCTUI_PAGE_VALUE}
      stepValue={2}
      handleBack={back}
      handleContinue={continueStep}
      handleSaveApplication={handleSaveApplication}
      disableCondition={isValidating}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continueBtn_id"
      screenLoading={isValidating}
      layoutImage={
        productMapping(productName) === ELITE_ACCOUNT_EN || productMapping(productName) === 'Ahorra'
          ? EliteImage2
          : businessMapping(productName) &&
            (productTypeMapping(productType) === 'Checking Account' ||
              productTypeMapping(productType) === 'Savings Account')
          ? ComercialImage3
          : RetailImage2
      }
    >
      <Box component="div" sx={styledClasses.product_grid_margin} data-page="product-info">
        {ProductIndexFunc()}
        {getProductForDebitCard(productName) === true && !isValidating ? productForDebitCard() : ''}
        {getProductForEstatement(productName) && !isValidating ? productForEStatement() : ''}
        {getProductForDepositeCard(productName) === true && !isValidating
          ? productForDepositeCard()
          : ''}
        {!isValidating && isCDproduct(productName) && CDProduct()}
      </Box>
    </Layout>
  );
  const cdIRALayout = () => (
    <Layout
      ariaDescribedby="screenFiveHeading"
      headingId="screenFiveHeading"
      ariaDescribedbyId="screenFiveDesc"
      classes={styledClasses}
      descriptionKey={
        productMapping(productName) === 'Elite Account'
          ? 'Product Page Text Prog'
          : PRODUCTUI_PAGE_KEY
      }
      descriptionValue={PRODUCTUI_PAGE_VALUE}
      stepValue={2}
      handleBack={back}
      handleContinue={cdIraContinueStep}
      handleSaveApplication={handleSaveApplication}
      disableCondition={isValidating || leadGenerationContext?.productDataIRA?.knockOFf}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continueBtn_id"
      screenLoading={isValidating}
      layoutImage={
        productMapping(productName) === ELITE_ACCOUNT_EN ||
        productMapping(productName) === 'Ahorra' ||
        isCDIraproduct(productName)
          ? EliteImage2
          : businessMapping(productName) &&
            (productTypeMapping(productType) === 'Checking Account' ||
              productTypeMapping(productType) === 'Savings Account')
          ? ComercialImage3
          : RetailImage2
      }
    >
      <ProductCDIRA history={history} />
    </Layout>
  );
  const bundleLayout = () => (
    <NewLayout
      handleContinue={continueStep}
      handleBack={back}
      stepValue={3}
      handleSaveApplication={handleSaveApplication}
      disableCondition={isValidating}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continueBtn_id"
      screenLoading={isValidating}
    >
      {productData?.questions?.[0]?.groupHeader && (
        <Grid size={{ xs: 12 }} style={{ marginBottom: '22px' }} data-page="product-info">
          <Box
            component="span"
            // sx={classes.quesTitleStyle}
            aria-label={translation[productData.questions[0].groupHeader]}
          >
            {translation[productData.questions[0].groupHeader]}
          </Box>
        </Grid>
      )}

      <Grid container sx={[layoutClasses.mailingAddressSwitchContainer, layoutClasses.fullWidth]}>
        <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10 }} sx={layoutClasses.tooltipStyle}>
          <Typography component="h4" variant="subtitle1" sx={layoutClasses.text}>
            {t(APPLY_TWO_ACCOUNTS, {
              defaultValue: APPLY_TWO_ACCOUNTS,
            })}
          </Typography>
        </Grid>

        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} sx={layoutClasses.switchPosition}>
          <CustomSwitch
            id="editHomeAddress"
            ariaLabelName={`${t(APPLY_TWO_ACCOUNTS, {
              defaultValue: APPLY_TWO_ACCOUNTS,
            })}`}
            defaultData={!!productAccountType}
            ariaLabelledby="toggleone"
            handleClickCheckbox={(e) => {
              setProductAccountType(!productAccountType);
              setItemsAnswerSavings({});
              setFormAnswerSavings({});
              setFormAnswer({});
              setItemsAnswer({});
              setProductTabVal(0);
            }}
            isBundle={isBundle(productName)}
            // toggleCheckboxOnEnter={toggleCheckboxOnEnter}
            dataTestId="editHomeAddress_testId"
          />
        </Grid>
      </Grid>
      {!productAccountType ? (
        <CommonTab checkingProduct={ProductIndexFunc} savingProduct={ProductIndexFuncSavings} />
      ) : (
        <>
          <Typography component="p" variant="subtitle1" marginY="20px" sx={layoutClasses.subtext}>
            {t(productName, {
              defaultValue: productName,
              nsSeparator: '|',
            })}
          </Typography>
          {ProductIndexFunc()}
        </>
      )}

      {getProductForDebitCard(productName) === true && !isValidating ? productForDebitCard() : ''}
      {getProductForEstatement(productName) && !isValidating ? productForEStatement() : ''}
      {getProductForDepositeCard(productName) === true && !isValidating
        ? productForDepositeCard()
        : ''}
      {!isValidating && isCDproduct(productName) && CDProduct()}
    </NewLayout>
  );

  const productForDebitCard = () => (
    <Box
      component="div"
      role="application"
      aria-roledescription={t('Debit Card', {
        defaultValue: 'Debit Card',
      })}
      aria-describedby="debitCardDisclaimerId"
      sx={styledClasses.debCard}
    >
      <Grid size={{ xs: 12 }} sx={styledClasses.titleborder}>
        <Box
          component="span"
          sx={styledClasses.quesTitleStyle}
          aria-label={t(DEBIT_CARD, {
            defaultValue: DEBIT_CARD,
          })}
        >
          {t(DEBIT_CARD, {
            defaultValue: DEBIT_CARD,
          })}
        </Box>
      </Grid>
      <Grid container>
        <Grid
          id="debitCardDisclaimerId"
          size={{ xs: 12, md: 12 }}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Box component="span" sx={styledClasses.quesTitleSubHeadingStyle}>
            {t(DEBIT_CARD_INFO_TEXT, {
              defaultValue: DEBIT_CARD_INFO_TEXT,
              nsSeparator: '|',
            })}
          </Box>
        </Grid>
      </Grid>
      <Box
        component="div"
        style={{
          display: isMobile ? 'inline-grid' : 'inline-flex',
        }}
        sx={styledClasses.radioLayout}
      >
        <div style={{ marginBottom: isMobile ? '20px' : '0px' }}>
          <Box component="label" sx={{ display: 'flex' }}>
            <CustomRadio
              size="small"
              sx={styledClasses.radioRoot}
              checked={debitCardDisburse}
              onChange={handleDebitCardRequiredRadio}
              onKeyDown={handleDebitCardRequiredRadioOnEnter}
              value={DEBIT_CARD_REQUIRED_TEXT}
              inputProps={{
                'data-testid': 'mail_my_card_testid',
              }}
              id="ship the debit card"
              name="ship the debit card"
            />
            <InputLabel
              aria-label={t(DEBIT_CARD_REQUIRED_TEXT, {
                defaultValue: DEBIT_CARD_REQUIRED_TEXT,
              })}
              style={{ marginRight: '16px' }}
              // for="ship the debit card"
              sx={styledClasses.radioLabelStyle}
            >
              {t(DEBIT_CARD_REQUIRED_TEXT, {
                defaultValue: DEBIT_CARD_REQUIRED_TEXT,
              })}
            </InputLabel>
          </Box>
        </div>
        <div style={{ marginBottom: isMobile ? '10px' : '0px' }}>
          <Box component="label" sx={{ display: 'flex' }}>
            <CustomRadio
              size="small"
              sx={styledClasses.radioRoot}
              checked={debitCardNotRequired}
              onChange={handleDebitCardNotReqRadio}
              onKeyDown={handleDebitCardNotReqRadioOnEnter}
              value={DEBIT_CARD_NOT_REQUIRED_TEXT}
              inputProps={{
                'data-testid': 'second_checkbox_testid',
              }}
              id="ship the debit card"
              name="ship the debit card"
            />

            <InputLabel sx={styledClasses.radioLabelStyle}>
              {t(DEBIT_CARD_NOT_REQUIRED_TEXT, {
                defaultValue: DEBIT_CARD_NOT_REQUIRED_TEXT,
              })}
            </InputLabel>
          </Box>
        </div>
      </Box>
    </Box>
  );

  const productForDepositeCard = () => (
    <Box
      component="div"
      role="application"
      aria-roledescription={t('Direct Deposit', {
        defaultValue: 'Direct Deposit',
      })}
      aria-describedby="directDepositDisclaimerId"
      sx={styledClasses.debCard}
    >
      <Grid size={{ xs: 12 }} sx={styledClasses.titleborderdeposite}>
        <Box
          component="span"
          sx={styledClasses.quesTitleStyleDeposite}
          aria-label={t(DIRECT_DEPOSITE, {
            defaultValue: DIRECT_DEPOSITE,
          })}
        >
          {t(DIRECT_DEPOSITE, {
            defaultValue: DIRECT_DEPOSITE,
          })}
        </Box>
      </Grid>
      <Grid container>
        <Grid
          id="directDepositDisclaimerId"
          size={{ xs: 12, md: 12 }}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Box component="span" sx={styledClasses.quesTitleSubHeadingStyle}>
            {t(DIRECT_DEPOSITE_TEXT, {
              defaultValue: DIRECT_DEPOSITE_TEXT,
              nsSeparator: '|',
            })}
          </Box>
        </Grid>
      </Grid>
      <Box
        component="div"
        style={{
          display: isMobile ? 'inline-grid' : 'inline-flex',
        }}
        sx={styledClasses.radioLayoutDeposite}
      >
        <div style={{ marginBottom: isMobile ? '28px' : '0px' }}>
          <Box component="label" sx={{ display: 'flex' }}>
            <CustomRadio
              size="small"
              sx={styledClasses.radioRoot}
              checked={depositeCardDisburse === DIRECT_DEPOSITE_RADIO_TEXT}
              onChange={handleDepositeCardRequiredRadio}
              onKeyDown={handleDepositeCardRequiredRadioOnEnter}
              value={DIRECT_DEPOSITE_RADIO_TEXT}
              inputProps={{
                'data-testid': 'mail_my_card_testid',
              }}
              // id="direct deposit"
              name="direct deposit"
              // aria-label="ship the debit card"
            />
            {/* <InputLabel */}
            <Typography
              style={{ marginRight: '16px' }}
              variant="subtitle1"
              // for="ship the debit card"
              aria-label={t(DIRECT_DEPOSITE_RADIO_TEXT, {
                defaultValue: DIRECT_DEPOSITE_RADIO_TEXT,
              })}
              sx={styledClasses.radioLabelStyle}
            >
              {t(DIRECT_DEPOSITE_RADIO_TEXT, {
                defaultValue: DIRECT_DEPOSITE_RADIO_TEXT,
              })}
              {/* </InputLabel> */}
            </Typography>
          </Box>
        </div>
        <div>
          <Box component="label" sx={{ display: 'flex' }}>
            <CustomRadio
              size="small"
              sx={styledClasses.radioRoot}
              checked={depositeCardDisburse === DIRECT_DEPOSITE_RADIO_TEXT_NO}
              onChange={handleDepositeCardRequiredRadio}
              onKeyDown={handleDepositeCardRequiredRadioOnEnter}
              value={DIRECT_DEPOSITE_RADIO_TEXT_NO}
              inputProps={{
                'data-testid': 'second_checkbox_testid',
              }}
              name="direct deposit"
            />
            <Typography
              variant="subtitle1"
              aria-label={t(DIRECT_DEPOSITE_RADIO_TEXT_NO, {
                defaultValue: DIRECT_DEPOSITE_RADIO_TEXT_NO,
              })}
              sx={styledClasses.radioLabelStyle}
            >
              {t(DIRECT_DEPOSITE_RADIO_TEXT_NO, {
                defaultValue: DIRECT_DEPOSITE_RADIO_TEXT_NO,
              })}
            </Typography>
          </Box>
        </div>
      </Box>
    </Box>
  );

  const productForEStatement = () => (
    <Box
      component="div"
      role="application"
      aria-labelledby="EStatementText0 EStatementText1 EStatementText2"
      aria-describedby="EStatementText3"
      sx={styledClasses.debCard}
    >
      <Grid size={{ xs: 12 }} sx={styledClasses.titleborder}>
        <Box
          component="span"
          id="EStatementText0"
          sx={styledClasses.quesTitleStyle}
          aria-label={t(
            commonTernary(
              productName === PROGRESA_CONTIGO,
              PROGRESA_CONTIGO_ESTATEMENT,
              E_STATEMENTS
            ),
            {
              defaultValue: commonTernary(
                productName === PROGRESA_CONTIGO,
                PROGRESA_CONTIGO_ESTATEMENT,
                E_STATEMENTS
              ),
            }
          )}
        >
          {t(
            commonTernary(
              productName === PROGRESA_CONTIGO,
              PROGRESA_CONTIGO_ESTATEMENT,
              E_STATEMENTS
            ),
            {
              defaultValue: commonTernary(
                productName === PROGRESA_CONTIGO,
                PROGRESA_CONTIGO_ESTATEMENT,
                E_STATEMENTS
              ),
            }
          )}
        </Box>
      </Grid>
      <Grid container>
        <Grid size={{ xs: 12, md: 12 }} style={{ display: 'flex', alignItems: 'center' }}>
          <Box
            component="span"
            sx={styledClasses.quesTitleSubHeadingStyle}
            id="EStatementText1"
            aria-label={t(
              commonTernary(
                productName === PROGRESA_CONTIGO,
                PROGRESA_CONTIGO_ESTATEMENT_TEXT,
                ESTATEMENT_TEXT
              ),
              {
                defaultValue: commonTernary(
                  productName === PROGRESA_CONTIGO,
                  PROGRESA_CONTIGO_ESTATEMENT_TEXT,
                  ESTATEMENT_TEXT
                ),
                nsSeparator: '|',
              }
            )}
          >
            {t(
              commonTernary(
                productName === PROGRESA_CONTIGO,
                PROGRESA_CONTIGO_ESTATEMENT_TEXT,
                ESTATEMENT_TEXT
              ),
              {
                defaultValue: commonTernary(
                  productName === PROGRESA_CONTIGO,
                  PROGRESA_CONTIGO_ESTATEMENT_TEXT,
                  ESTATEMENT_TEXT
                ),
                nsSeparator: '|',
              }
            )}
            <Box
              component="span"
              id="EStatementText2"
              sx={styledClasses.quesTitleBankingSubHeading}
              aria-label={t(
                commonTernary(
                  productName === PROGRESA_CONTIGO,
                  PROGRESA_CONTIGO_BANKING,
                  ESTATEMENT_BANKING
                ),
                {
                  defaultValue: commonTernary(
                    productName === PROGRESA_CONTIGO,
                    PROGRESA_CONTIGO_BANKING,
                    ESTATEMENT_BANKING
                  ),
                  nsSeparator: '|',
                }
              )}
            >
              {t(
                commonTernary(
                  productName === PROGRESA_CONTIGO,
                  PROGRESA_CONTIGO_BANKING,
                  ESTATEMENT_BANKING
                ),
                {
                  defaultValue: commonTernary(
                    productName === PROGRESA_CONTIGO,
                    PROGRESA_CONTIGO_BANKING,
                    ESTATEMENT_BANKING
                  ),
                  nsSeparator: '|',
                }
              )}
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }} style={{ display: 'flex', alignItems: 'center' }}>
          <Box component="span" sx={styledClasses.quesTitleSubHeadingStyle} id="EStatementText3">
            {t(
              commonTernary(
                productName === PROGRESA_CONTIGO,
                PROGRESA_CONTIGO_MONTHLY_FEE,
                E_STATEMENT_MONTHLY_FEE
              ),
              {
                defaultValue: commonTernary(
                  productName === PROGRESA_CONTIGO,
                  PROGRESA_CONTIGO_MONTHLY_FEE,
                  E_STATEMENT_MONTHLY_FEE
                ),
                nsSeparator: '|',
              }
            )}
          </Box>
        </Grid>
        <Grid
          size={{ xs: 12, md: 12, lg: 12 }}
          style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}
        >
          <Box
            component="img"
            src={InfoIcon}
            width="20px"
            height="20px"
            tabIndex="0"
            alt={t(
              commonTernary(
                productName === PROGRESA_CONTIGO,
                PROGRESA_CONTIGO_FEE_EXEMPTION,
                E_STATEMENT_FEE_WAIVED_AGED
              ),
              {
                defaultValue: commonTernary(
                  productName === PROGRESA_CONTIGO,
                  PROGRESA_CONTIGO_FEE_EXEMPTION,
                  E_STATEMENT_FEE_WAIVED_AGED
                ),
                nsSeparator: '|',
              }
            )}
            sx={styledClasses.imageIcon}
          />
          <Box component="span" sx={styledClasses.feeWaivedText}>
            {t(
              commonTernary(
                productName === PROGRESA_CONTIGO,
                PROGRESA_CONTIGO_FEE_EXEMPTION,
                E_STATEMENT_FEE_WAIVED_AGED
              ),
              {
                defaultValue: commonTernary(
                  productName === PROGRESA_CONTIGO,
                  PROGRESA_CONTIGO_FEE_EXEMPTION,
                  E_STATEMENT_FEE_WAIVED_AGED
                ),
                nsSeparator: '|',
              }
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );

  // eslint-disable-next-line react/no-unstable-nested-components
  const CDProduct = () => (
    <Box
      component="div"
      role="application"
      aria-roledescription={t('Interest Payment Method', {
        defaultValue: 'Interest Payment Method',
      })}
      aria-describedby="interestPaymentMethodId"
      sx={styledClasses.interestPaymentContainer}
    >
      {/* Interest Payment Method */}
      <Grid size={{ xs: 12 }} sx={styledClasses.titleInterestPaymentMethod}>
        <Box
          component="span"
          sx={styledClasses.quesTitleStyleDeposite}
          style={{ marginRight: '5px' }}
          aria-label={t(INTEREST_PAYMENT_METHOD, {
            defaultValue: INTEREST_PAYMENT_METHOD,
          })}
        >
          {t(INTEREST_PAYMENT_METHOD, {
            defaultValue: INTEREST_PAYMENT_METHOD,
          })}
        </Box>
        <CustomTooltip
          customAriaLabel={`${t(INTEREST_PAYMENT_METHOD, {
            defaultValue: INTEREST_PAYMENT_METHOD,
          })} ${t('More Info', { defaultValue: 'More Info' })}`}
          placement="right"
          text={t('Interest PaymentMethod Tooltip', {
            defaultValue: INTEREST_PAYMENT_METHOD_TEXT,
          })}
          tabIndex={0}
        />
      </Grid>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }} sx={styledClasses.interest_payment_method_padding}>
          <CustomSelect
            id="accuredIntMethod"
            dataTestId="accuredIntMethod_id"
            required
            inputLabelAriaLabel={`${t(SELECT_METHOD, {
              defaultValue: SELECT_METHOD,
            })} `}
            label={t(SELECT_METHOD, { defaultValue: SELECT_METHOD })}
            options={
              customerType === 'NTB' || accNoListForOrientalAccount.length === 0
                ? ['Deposit interest in this CD', 'Deposit interest in external account']
                : [
                    'Deposit interest in this CD',
                    'Deposit interest in Oriental account',
                    'Deposit interest in external account',
                  ]
            }
            inputProps={{
              'data-testid': 'accuredIntMethod',
            }}
            nsSeparator="|"
            handleChange={handleChangeIntrstPayment}
            fullWidth
            value={commonUtility(interestPaymentMethod?.accuredIntMethod)}
            selectAriaLabel={`${t('Aria Label Accrued interest method', {
              defaultValue:
                'Accrued interest method Required Select Accrued interest method dropdown menu button',
            })}`}
            error={interestPaymentMethodErr?.accuredIntMethod}
          />
          <Box component="span" role="alert" sx={styledClasses.error_message}>
            {t(interestPaymentMethodErr?.accuredIntMethod, {
              defaultValue: interestPaymentMethodErr?.accuredIntMethod,
            })}
          </Box>
        </Grid>
        {interestPaymentMethod?.accuredIntMethod === 'Deposit interest in Oriental account' &&
          accNoListForOrientalAccount?.length > 0 &&
          customerType === 'ETB' &&
          isPlaidProduct(productName) && (
            <Grid size={{ xs: 12, md: 6 }} sx={styledClasses.interest_payment_method_padding}>
              <CustomSelectAccountNo
                id="accountNumberOriental"
                required
                inputLabelAriaLabel={`${t(ACCOUNT_NUMBER, {
                  defaultValue: ACCOUNT_NUMBER,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(ACCOUNT_NUMBER, { defaultValue: ACCOUNT_NUMBER })}
                handleChange={handleChangeIntrstPayment}
                placeholder={t(ENTER_ACCOUNT_NUMBER, {
                  defaultValue: ENTER_ACCOUNT_NUMBER,
                })}
                fullWidth
                inputProps={{
                  maxLength: isPlaidProduct(productName) ? 17 : 16,
                  'data-testid': 'accountNumberOriental',
                }}
                selectAriaLabel={`${t('Aria Label Account Number', {
                  defaultValue:
                    'Account Number Required Select Account Number dropdown menu button',
                })}`}
                value={commonUtility(interestPaymentMethod?.Id)}
                error={commonUtility(interestPaymentMethodErr?.accountNumberOriental)}
                options={accNoListForOrientalAccount}
                nsSeparator="|"
                showLabel={false}
              />

              <Box
                component="span"
                sx={styledClasses.error_message}
                role="alert"
                data-testid="account-number-error"
              >
                {t(interestPaymentMethodErr?.accountNumberOriental, {
                  defaultValue: interestPaymentMethodErr?.accountNumberOriental,
                })}
              </Box>
            </Grid>
          )}

        {interestPaymentMethod?.accuredIntMethod === 'Deposit interest in external account' && (
          <>
            <Grid size={{ xs: 12, md: 6 }} sx={styledClasses.interest_payment_method_padding}>
              <CustomSelect
                id="typeOfAccount"
                dataTestId="typeOfAccount_id"
                required
                inputLabelAriaLabel={`${t(TYPE_OF_ACCOUNT, {
                  defaultValue: TYPE_OF_ACCOUNT,
                })} `}
                label={t(TYPE_OF_ACCOUNT, { defaultValue: TYPE_OF_ACCOUNT })}
                options={['Checking', 'Savings']}
                nsSeparator="|"
                handleChange={handleChangeIntrstPayment}
                fullWidth
                inputProps={{
                  'data-testid': 'typeOfAccount',
                }}
                value={commonUtility(interestPaymentMethod?.typeOfAccount)}
                selectAriaLabel={`${t('Aria Label Type Of Account', {
                  defaultValue:
                    'Type Of Account Required Select Type Of Account dropdown menu button',
                })}`}
                error={interestPaymentMethodErr?.typeOfAccount}
              />
              <Box component="span" role="alert" sx={styledClasses.error_message}>
                {t(interestPaymentMethodErr?.typeOfAccount, {
                  defaultValue: interestPaymentMethodErr?.typeOfAccount,
                })}
              </Box>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={styledClasses.interest_payment_method_padding}>
              <CustomInput
                id="accountNumber"
                dataTestId="accountNumber"
                required
                inputLabelAriaLabel={`${t(ACCOUNT_NUMBER, {
                  defaultValue: ACCOUNT_NUMBER,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(ACCOUNT_NUMBER, { defaultValue: ACCOUNT_NUMBER })}
                handleChange={handleChangeIntrstPayment}
                placeholder={t(ENTER_ACCOUNT_NUMBER, {
                  defaultValue: ENTER_ACCOUNT_NUMBER,
                })}
                fullWidth
                inputProps={{
                  maxLength: 17,
                  'data-testid': 'accountNumber_id',
                }}
                value={
                  interestPaymentMethod?.accountNumber ? interestPaymentMethod.accountNumber : ''
                }
                error={
                  interestPaymentMethodErr?.accountNumber
                    ? interestPaymentMethodErr.accountNumber
                    : ''
                }
              />
              <Box
                component="span"
                sx={styledClasses.error_message}
                role="alert"
                data-testid="account-number-error"
              >
                {t(interestPaymentMethodErr?.accountNumber, {
                  defaultValue: interestPaymentMethodErr?.accountNumber,
                })}
              </Box>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={styledClasses.interest_payment_method_padding}>
              <CustomSelect
                id="bank"
                dataTestId="bank_id"
                required
                inputLabelAriaLabel={`${t(BANK, { defaultValue: BANK })} `}
                label={t(BANK, { defaultValue: BANK })}
                options={banks}
                nsSeparator="|"
                handleChange={handleChangeIntrstPayment}
                fullWidth
                value={commonUtility(interestPaymentMethod?.bank)}
                error={interestPaymentMethodErr?.bank}
                selectAriaLabel={`${t('Aria Label Bank', {
                  defaultValue: 'Bank Required Select Bank dropdown menu button',
                })}`}
              />
              <Box component="span" role="alert" sx={styledClasses.error_message}>
                {t(interestPaymentMethodErr?.bank, {
                  defaultValue: interestPaymentMethodErr?.bank,
                })}
              </Box>
            </Grid>
            {interestPaymentMethod?.bank === OTHER ? (
              <Grid size={{ xs: 12, md: 6 }} sx={styledClasses.interest_payment_method_padding}>
                <CustomInput
                  id="otherBank"
                  dataTestId="otherBank_id"
                  required
                  inputLabelAriaLabel={`${t(BANK_NAME, { defaultValue: BANK_NAME })} ${t(REQUIRED, {
                    defaultValue: REQUIRED,
                  })}`}
                  label={t(BANK_NAME, { defaultValue: BANK_NAME })}
                  handleChange={handleChangeIntrstPayment}
                  placeholder={t('Enter Bank name', {
                    defaultValue: 'Enter Bank name',
                  })}
                  fullWidth
                  inputProps={{ 'data-testid': 'Other_bank', maxLength: 30 }}
                  value={commonUtility(interestPaymentMethod?.otherBank)}
                  error={commonUtility(interestPaymentMethodErr?.otherBank)}
                />
                <Box
                  component="span"
                  sx={styledClasses.error_message}
                  role="alert"
                  data-testid="otherBank-error"
                >
                  {t(interestPaymentMethodErr?.otherBank, {
                    defaultValue: interestPaymentMethodErr?.otherBank,
                  })}
                </Box>
              </Grid>
            ) : (
              ''
            )}
            <Grid size={{ xs: 12, md: 6 }} sx={styledClasses.interest_payment_method_padding}>
              {bankTransitNumbers && bankTransitNumbers.length > 1 ? (
                <CustomSelect
                  id="transitNumber"
                  dataTestId="transitNumber_id"
                  required
                  inputLabelAriaLabel={`${t(TRANSIT_NUMBER, {
                    defaultValue: TRANSIT_NUMBER,
                  })}`}
                  label={t(TRANSIT_NUMBER, { defaultValue: TRANSIT_NUMBER })}
                  handleChange={handleChangeIntrstPayment}
                  options={bankTransitNumbers}
                  nsSeparator="|"
                  fullWidth
                  value={commonUtility(interestPaymentMethod?.transitNumber)}
                  error={interestPaymentMethodErr?.transitNumber}
                  selectAriaLabel={`${t('Aria Label Transit', {
                    defaultValue:
                      'Transit Number Required Select Transit Number dropdown menu button',
                  })}`}
                />
              ) : (
                <CustomInput
                  id="transitNumber"
                  disabled={
                    bankTransitNumbers &&
                    bankTransitNumbers.length === 1 &&
                    bankTransitNumbers[0] !== OTHER &&
                    isPlaidProduct(leadGenerationContext.productName)
                  }
                  dataTestId="transitNumber_id"
                  required
                  inputLabelAriaLabel={`${t(TRANSIT_NUMBER, {
                    defaultValue: TRANSIT_NUMBER,
                  })}${t(REQUIRED, {
                    defaultValue: REQUIRED,
                  })}`}
                  label={t(TRANSIT_NUMBER, { defaultValue: TRANSIT_NUMBER })}
                  handleChange={handleChangeIntrstPayment}
                  handleBlur={handleBlurRouting}
                  placeholder={t('Enter Route & Transit Number', {
                    defaultValue: 'Enter Route & Transit Number',
                  })}
                  fullWidth
                  inputProps={{
                    maxLength: interestPaymentMethod?.bank === OTHER ? 9 : 25,
                    'data-testid': 'route-and-transit-number',
                    inputMode: 'numeric',
                  }}
                  value={commonUtility(interestPaymentMethod?.transitNumber)}
                  error={commonUtility(interestPaymentMethodErr?.transitNumber)}
                />
              )}

              <Box
                component="span"
                sx={styledClasses.error_message}
                role="alert"
                data-testid="route-and-transit-number-error"
              >
                {t(interestPaymentMethodErr?.transitNumber, {
                  defaultValue: interestPaymentMethodErr?.transitNumber,
                })}
              </Box>
            </Grid>
            {interestPaymentMethod?.transitNumber === 'Other' && (
              <Grid size={{ xs: 12, md: 6 }} sx={styledClasses.interest_payment_method_padding}>
                <CustomInput
                  id="customTransitNumber"
                  // disabled={
                  //   bankTransitNumbers &&
                  //   bankTransitNumbers.length === 1 &&
                  //   isPlaidProduct(leadGenerationContext.productName)
                  // }
                  dataTestId="custom_transitNumber_id"
                  required
                  inputLabelAriaLabel={`${t(ENTER_TRANSIT_NUMBER, {
                    defaultValue: ENTER_TRANSIT_NUMBER,
                  })}${t(REQUIRED, {
                    defaultValue: REQUIRED,
                  })}`}
                  label={t(ENTER_TRANSIT_NUMBER, { defaultValue: ENTER_TRANSIT_NUMBER })}
                  handleChange={handleChangeIntrstPayment}
                  handleBlur={handleBlurRouting}
                  placeholder={t('Enter Route & Transit Number', {
                    defaultValue: 'Enter Route & Transit Number',
                  })}
                  fullWidth
                  inputProps={{
                    maxLength: interestPaymentMethod?.transitNumber === OTHER ? 9 : 25,
                    'data-testid': 'customTransitNumber',
                    inputMode: 'numeric',
                  }}
                  value={commonUtility(interestPaymentMethod?.customTransitNumber)}
                  error={commonUtility(interestPaymentMethodErr?.customTransitNumber)}
                />
                <Box
                  component="span"
                  sx={styledClasses.error_message}
                  role="alert"
                  data-testid="route-and-transit-number-error"
                >
                  {t(interestPaymentMethodErr?.customTransitNumber, {
                    defaultValue: interestPaymentMethodErr?.customTransitNumber,
                  })}
                </Box>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Box>
  );

  return (
    <>
      {isBundle(productName)
        ? bundleLayout()
        : productName === CD_IRA
        ? cdIRALayout()
        : oldLayout()}

      {isModalSaveLater && (
        <SaveAppContactInfo openModal={isModalSaveLater} currentPage="product-info" />
      )}
    </>
  );
}

export default withRouter(Product);

Product.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
